import styled from '@emotion/styled'
import { ChangeEvent, Dispatch, SetStateAction } from 'react';

type NumberBoxProps = 
{ 
  min?: number
  max?: number
  value?: number
  amount: number
  setAmount: Dispatch<SetStateAction<number>>
  onChange?:(event:ChangeEvent<HTMLInputElement>) => void
}

const Content = styled.input`
border: 1px solid rgba(0, 0, 0, 0);
margin: 0.5rem;
padding: 0.5rem;
border-radius: 2px 2px 2px 2px;
box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19);
&:focus{
  background-color: #DBD5E5;
  outline: none;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
`

export function NumberBox({ min, max, value = 0, amount, setAmount, onChange }: NumberBoxProps){
  function updateValue(event:ChangeEvent<HTMLInputElement>)
  {
    setAmount(event.target.valueAsNumber)
    if(onChange)
    {
      onChange(event)
    }
  }

  return (
        <Content type='number' min={min} max={max} value={amount} onChange={updateValue}>
        </Content>
  )
}
